var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddIconCircleBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 33.6654C8.29565 33.6654 0.833984 26.2037 0.833984 16.9987C0.833984 7.7937 8.29565 0.332031 17.5007 0.332031C26.7057 0.332031 34.1673 7.7937 34.1673 16.9987C34.1673 26.2037 26.7057 33.6654 17.5007 33.6654ZM15.834 15.332H9.66732C9.39118 15.332 9.16732 15.5559 9.16732 15.832V18.1654C9.16732 18.4415 9.39118 18.6654 9.66732 18.6654H15.834V24.832C15.834 25.1082 16.0578 25.332 16.334 25.332H18.6673C18.9435 25.332 19.1673 25.1082 19.1673 24.832V18.6654H25.334C25.6101 18.6654 25.834 18.4415 25.834 18.1654V15.832C25.834 15.5559 25.6101 15.332 25.334 15.332H19.1673V9.16536C19.1673 8.88922 18.9435 8.66537 18.6673 8.66537H16.334C16.0578 8.66537 15.834 8.88922 15.834 9.16537V15.332Z",
    fill: "#19305A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddIconCircleBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addIconCircleBlue.5e8b397e.svg";
export { ForwardRef as ReactComponent };